import React, { ComponentProps } from 'react'

import { Stack } from '@zet/design-system/layout'
import { B4, B5 } from '@zet/design-system/typography'
import { styled } from 'nativewind'

const LeadStatusContainer = styled(Stack, ' rounded border-l-2  py-2 px-3 ', {
  variants: {
    intent: {
      active: 'border-l-secondary-100 bg-[#E9F4FC]',
      error: 'border-l-error-100 bg-[#FFF0F0]',
      warning: 'border-l-warning-100 bg-[#FFF4EA] ',
      success: ' border-l-success-50 bg-[#E9FCE9] ',
    },
  },
  defaultProps: {
    intent: 'active',
  },
})

type LeadStatusFrameProps = ComponentProps<typeof LeadStatusContainer>

type LeadStatusCardProps = LeadStatusFrameProps & {
  content: {
    title: string | undefined
    description?: string | undefined
  }
  intent?: 'active' | 'error' | 'warning' | 'success' | undefined
}

const LeadStatusCard = ({ content, intent, ...props }: LeadStatusCardProps) => {
  return (
    <LeadStatusContainer intent={intent} {...props}>
      {!content?.description && <Stack className="h-2" />}
      <B4 className=" text-grays-80 ">{content?.title}</B4>
      {!content?.description && <Stack className="h-2" />}

      {content?.description && (
        <B5 className="text-grays-60" numberOfLines={2}>
          {content?.description}
        </B5>
      )}
    </LeadStatusContainer>
  )
}

export { LeadStatusCard }
